import { Texto } from '@gravitate-js/excalibrr'
import React from 'react'

export function LidCodeIcon({
  lidUrl,
  productName,
  showBackground = true,
}: {
  lidUrl: string
  productName: string
  showBackground?: boolean
}) {
  if (!lidUrl) return <Texto>&mdash;</Texto>
  return (
    <div
      style={{
        border: showBackground ? '1px solid var(--gray-200)' : 'none',
        background: showBackground ? 'var(--bg-2)' : 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: showBackground ? 1 : 0,
      }}
    >
      <img src={lidUrl} style={{ width: '24px' }} />
    </div>
  )
}
